import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Button from '../../../src/components/pages/ui/Button/Button';
import './NewCarsOffers.scss';

export default function NewCarsOffers({ fields, buttonConfig }) {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getItemTitle = (item) => {
    let defaultText = '';

    if (item && item.fields) {
      return item.fields.title?.value || '';
    }

    return defaultText;
  };

  const getImageUrl = (item) => {
    let result = '';

    if (item && item.fields) {
      const getImageUrlFromField = (imageField) => {
        if (!imageField?.fields) return '';

        if (isMobile) {
          return (
            imageField.fields.mobileImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            ''
          );
        } else if (isTablet) {
          return (
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        } else {
          return (
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        }
      };

      result = getImageUrlFromField(item.fields.image);

      return result;
    }

    return result;
  };

  const getItemContent = (item) => {
    let defaultContent = [];

    if (item?.fields?.list?.length) {
      return item.fields.list || [];
    }

    return defaultContent;
  };

  const [getItemContentIndex, setGetItemContentIndex] = useState(0);

  const handleBrandSelect = (index) => {
    setGetItemContentIndex(index);
  };

  const getButton = (item) => {
    if (item && item.fields) {
      const buttonPath = item.fields.buttonPath?.value;
      const query = buttonPath?.querystring || '';

      if (buttonPath) {
        return {
          path:
            buttonPath.href || buttonPath.url || buttonConfig?.defaultButtonPath
              ? (buttonPath.href || buttonPath.url || buttonConfig?.defaultButtonPath) + query
              : '#',
          text: 'VIEW OFFER',
          target: buttonPath.target || '_self',
        };
      }
    }
    return null;
  };

  return (
    <div className="NewCarsOffersComp">
      <div
        className="NewCarsOffersTitle"
        dangerouslySetInnerHTML={{ __html: fields.title?.value }}
      ></div>

      <div className="NewCarsOffersListOut">
        <div className="NewCarsOffersList">
          {fields?.list?.length
            ? fields.list.map((val, e) => {
                return (
                  <div
                    className={`${'NewCarsOffersListItem'} ${
                      e === getItemContentIndex ? 'selected' : ''
                    }`}
                    key={e}
                    onClick={() => handleBrandSelect(e)}
                  >
                    {getItemTitle(val)}
                  </div>
                );
              })
            : ''}
        </div>
      </div>

      <div className="NewCarsOffersListItemContent">
        {fields?.list?.length
          ? getItemContent(fields.list[getItemContentIndex]).map((val, e) => {
              const button = getButton(val);

              return (
                <div className="NewCarsOffersListItemContentItem" key={e}>
                  <div className="NewCarsOffersListItemContentItemImage">
                    <img src={getImageUrl(val)} alt="" />
                  </div>

                  <section className="NewCarsOffersListItemContentItemBlock1">
                    <section className="NewCarsOffersListItemContentItemBlock1Left">
                      <em>{val.fields.title?.value}</em>
                      <p>{val.fields.remarks?.value}</p>
                    </section>

                    <section className="NewCarsOffersListItemContentItemBlock1Right">
                      {val.fields.tips?.value}
                    </section>
                  </section>

                  <section className="NewCarsOffersListItemContentItemBlock2">
                    <section className="NewCarsOffersListItemContentItemBlock2Square">
                      <em>{val.fields.subTitle1?.value}</em>
                      <p>{val.fields.subRemarks1?.value}</p>
                    </section>

                    <section className="NewCarsOffersListItemContentItemBlock2Square">
                      <em>{val.fields.subTitle2?.value}</em>
                      <p>{val.fields.subRemarks2?.value}</p>
                    </section>
                  </section>

                  {button && (
                    <div className="NewCarsOffersListItemContentItem_button">
                      {button && (
                        <Button className="button" isShowTooltip={false} target={button.path}>
                          {button.text}
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          : ''}
      </div>
    </div>
  );
}
